import { ConfigService } from './../config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IInstitution } from '@stockcare-models/IInstitution';

@Injectable({
    providedIn: 'root'
})
export class InstitutionsService {
    constructor(private http: HttpClient, private conf: ConfigService) {}

    get(): Observable<IInstitution[]> {
        return this.http.get<IInstitution[]>(
            `${this.conf.config.baseUrl}/institutions`
        );
    }
}
